const SectionTitle = ({ title }) => {
    return (
        <div className="faqmate-section">
            <h2 className="faqmate-section-title">{title}</h2>
        </div>
    );
};

export default SectionTitle;
